// Default config passed to i18n init (can be overridden)
export const defaultI18nConfig = {
    fallbackLng: {
        ca: ['ca-ES', 'ca', 'en'],
        fr: ['fr-FR', 'en'],
        'ja-JP': ['ja', 'en'],
        'es-*': ['es', 'en'],
        'en-GB-*': ['en-GB', 'en'],
        default: ['en'],
    },
    detection: {
        // An empty array is passed to prevent default localStorage caching
        caches: [],
        lookupQuerystring: 'lang_code',
        order: ['htmlTag', 'querystring', 'navigator'],
    },
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    react: {
        useSuspense: true,
    },
};
/**
 * Resolves a locale string to its fallback based on i18next fallbackLng config.
 *
 * @example
 * resolveFallbackLocale('ja-TEST', validLocales) // 'ja'
 * resolveFallbackLocale('ca', validLocales)      // 'ca-ES'
 * resolveFallbackLocale('es-MX', validLocales)   // 'es'
 */
export function resolveFallbackLocale(locale, validLocales) {
    if (!locale) {
        return null;
    }
    const fallbackConfig = defaultI18nConfig.fallbackLng;
    const findValid = (fallbacks) => fallbacks?.find((fb) => validLocales.has(fb));
    // Explicit fallback (e.g., 'ja-JP' -> ['ja'])
    const explicit = findValid(fallbackConfig[locale]);
    if (explicit) {
        return explicit;
    }
    // Exact match
    if (validLocales.has(locale)) {
        return locale;
    }
    // Wildcard fallback (e.g., 'es-MX' -> 'es')
    const baseLocale = locale.split('-')[0];
    const wildcard = findValid(fallbackConfig[`${baseLocale}-*`]);
    if (wildcard) {
        return wildcard;
    }
    // Base locale fallback rules (e.g., 'ca-FAKE' -> 'ca' -> ['ca-ES', 'ca', 'en'] -> 'ca-ES')
    const baseFallback = findValid(fallbackConfig[baseLocale]);
    if (baseFallback) {
        return baseFallback;
    }
    // Base locale
    return validLocales.has(baseLocale) ? baseLocale : null;
}
